module.exports = __webpack_public_path__ + "static/media/bot-avatar.d709758b.png";